module.exports = __webpack_public_path__ + "static/media/square-logo.7160797c.svg";